import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'dgx-search-sidebar-error',
  templateUrl: './search-sidebar-error.component.html',
  styleUrls: ['./search-sidebar-error.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SearchSidebarErrorComponent {
  @Input() public collectionName: string;

  constructor(private translateService: TranslateService) {}

  public get errorMessage(): string {
    return this.translateService.instant('LearningSearch_ErrorTitleSideBar');
  }
}
